import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Component({
  selector: 'confirm',
  templateUrl: './confirm.component.html',
  styleUrls: [ './confirm.component.scss' ]
})
export class ConfirmComponent implements OnInit {

  constructor(private httpClient: HttpClient,
              private route: ActivatedRouteSnapshot,
              private router: Router) {
  }

  ngOnInit() {
    if (!this.route.queryParamMap.has('t')) {
      this.router.navigate([ '/login' ]);
      return;
    }

    const hash = this.route.queryParamMap.get('t');
    this.httpClient.post('/account/confirm', { hash })
      .subscribe(
        response => {
          this.router.navigate([ '/' ]);
        }, err => {
          this.router.navigate([ '/' ]);
        }
      );
  }

}
